<!-- title -->
<template>
  <div class="name">
    {{ title }}
  </div>
</template>

<script>
  export default {
    name: 'H3Title',
    props: {
      title: {
        type: String,
        default: '概况'
      }
    },
    mounted(){
      
    }
  };
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
.name{
  color: #fff;
  border-left: 5px solid #a7231e;
  padding-left: 8px;
  line-height: 20px;
  font-size: 16px;
}
</style>
